import formatPrice from './formatPrice';

const getPriceRange = (pricesWithCurrencies, locale) => pricesWithCurrencies
  .map((priceWithCurrency) => {
    const { range: { minimum, maximum }, currency } = priceWithCurrency;

    return minimum === maximum
      ? formatPrice(minimum, currency, locale)
      : `${formatPrice(minimum, currency, locale)}-${
        formatPrice(maximum, currency, locale)
      }`;
  })
  .join(', ');

export default getPriceRange;
